import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class PilotWhitelist extends MongoEntity {
  static override _class = 'PilotWhitelist';
  static override _collectionName = 'pilot_whitelist';

  @Field(() => String)
  email!: string;
}

@Entity()
export class Waitlist extends MongoEntity {
  static override _class = 'Waitlist';
  static override _collectionName = 'waitlist';

  @Field(() => String)
  email!: string;

  @Field(() => String)
  timestamp!: string;
}
